<span>
    {{ displayDate }}
</span>